<template>
  <div>
    <PageTitle :title="title"></PageTitle>
    <div class="ct_wrapper">
      <p v-if="lang ==='ru'">
        Если у вас есть желание сотрудничать со мной, то можете воспользоваться формой или другими приведёнными способами связи.
      </p>
      <p v-else>
        If you have a desire to cooperate with me, then you can use the form or other methods of communication given above.
      </p>
      <div class="clearfix">
        <div class="col">
          <form method="POST" action="" class="contact_form">
            <p><label for="name">Ваше имя: </label><input id="name" name="name" type="text" value=""></p>
            <p><label for="email">Ваш email: </label><input id="email" name="email" type="text" value=""><br></p>
            <p>
            </p>
            <p><label for="message" style="width: 140px;">Ваше предложение: </label><br><textarea id="message"
                                                                                                  name="message"></textarea>
            </p>
            <div class="text-right"><input type="submit"></div>
          </form>
        </div>
        <div class="col links">
          <a href="mailto:mail@go-sha.ru"><img src="../assets/img/icons/mailicon.png"
                                               class="mailicon">mail@go-sha.ru</a><br><br>
          <img src="../assets/img/icons/skype.png" class="skype"><span>egor.kotov77</span><br><br>
          <a href="https://vk.com/ekotov77" target="_blank"><img src="../assets/img/icons/vk.png"
                                                                 class="vk">ekotov77</a><br><br>
          <img src="../assets/img/icons/geo.png" class="geo"><span>Новосибирск</span><br><br>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageTitle from '@/components/PageTitle.vue'

export default {
  name: 'Contacts',
  data() {
    return {
    }
  },
  computed: {

  },
  props: {
    lang: String,
    title: String
  },
  components: {
    PageTitle
  }
}
</script>